import type { Translate } from '@platform/i18n';
import type { RecipientInputLabels } from '../mail/recipient-input';

/** One label mapping for console entity/address-list selection; composites remain prop-based. */
export function entityPickerLabelsFor(t: Translate): RecipientInputLabels {
  return {
    suggestions: t('common.entityPicker.suggestions'), searching: t('webmail.recipients.searching'),
    noMatches: t('common.entityPicker.noMatches'), lookupFailed: t('common.entityPicker.lookupFailed'),
    retry: t('common.retry'), loadMore: t('admin.users.rights.loadMore'), searchLimit: t('admin.users.rights.searchLimit'),
    remove: t('webmail.recipients.remove'), removeSuggestion: t('webmail.recipients.removeSuggestion'),
    expandGroup: t('webmail.recipients.expandGroup'), unresolved: t('webmail.recipients.unresolved'),
    ambiguous: t('webmail.recipients.ambiguous'), invalid: t('webmail.recipients.invalid'),
    pending: t('common.entityPicker.pending'), chooseCandidate: t('webmail.recipients.chooseCandidate'),
    group: t('webmail.recipients.group'),
    sources: { recent: t('webmail.recipients.sources.recent'), contact: t('webmail.recipients.sources.contact'), gal: t('webmail.recipients.sources.gal'), external: t('webmail.recipients.sources.external') },
  };
}
